import BaseDialog from '~/common/components/dialogs/BaseDialog';

import type { PropsWithChildren, ReactNode } from 'react';

export interface ConfirmProps extends PropsWithChildren {
  title?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  /** 확인 버튼을 danger(빨강) 스타일로 — 비가역/금전 액션(환불 등)에서 변별 강조. */
  okDanger?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}

function ConfirmDialog({
  title,
  children,
  confirmLabel,
  cancelLabel,
  okDanger,
  onCancel,
  onConfirm,
}: ConfirmProps) {
  return (
    <BaseDialog
      title={title}
      cancelText={cancelLabel || '취소'}
      okButtonProps={{ danger: okDanger }}
      okText={confirmLabel || '확인'}
      onCancel={onCancel}
      onOk={onConfirm}
    >
      {children}
    </BaseDialog>
  );
}

export default ConfirmDialog;
